import { CopyIcon, OpenInNewIcon } from '../icons'
import Button from '../buttons/button'
import Tag from '../badgesAndTags/tag'
import {
	TypographyHeading,
	TypographyLabel,
	TypographyParagraph,
} from '../typography'
import { Tooltip, TooltipRefProps } from 'react-tooltip'
import Image from '../content/Image'
import { useRef } from 'react'

const formatDate = (date: string) => {
	try {
		const options = {
			year: 'numeric',
			month: 'short',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			hour12: true,
		}
		const dateObj = new Date(date)
		//@ts-ignore
		return dateObj.toLocaleDateString('en-US', options)
	} catch (e) {
		return date
	}
}

export default function TweetImport({ tweet }: { tweet: any }) {
	const tooltipCopyIPFS = useRef<TooltipRefProps>(null)
	const tooltipCopyArweave = useRef<TooltipRefProps>(null)

	return (
		<div className="flex flex-col gap-y-4">
			<div className="flex flex-col rounded bg-uiTertiaryLight p-4 dark:bg-uiTertiaryDark">
				<div className="flex flex-row items-center justify-between">
					<TypographyHeading
						size="small"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						Timestamp
					</TypographyHeading>
					<div className="flex flex-row gap-x-2">
						<a href={tweet.ipfsURL} target="_blank">
							<Button variant="secondary" leftIcon={<OpenInNewIcon />}>
								View in IPFS
							</Button>
						</a>
						<a href={tweet.arweaveURL} target="_blank">
							<Button variant="primary" leftIcon={<OpenInNewIcon />}>
								View in Arweave
							</Button>
						</a>
					</div>
				</div>
				<div className="mt-4 flex flex-row items-center gap-x-2">
					<TypographyLabel
						size="medium"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						Arweave Transaction:
					</TypographyLabel>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.arweaveCID}
					</TypographyParagraph>
					<div id="copyArweave" className="flex flex-row">
						<CopyIcon
							className="h-4 w-4 text-textSecondaryLight hover:cursor-pointer dark:text-textSecondaryDark"
							onClick={() => {
								navigator.clipboard.writeText(tweet.arweaveCID)
								tooltipCopyArweave.current?.open({
									anchorSelect: '#copyArweave',
									content: 'Copied!',
								})
								setTimeout(() => {
									tooltipCopyArweave.current?.close()
								}, 2000)
							}}
						/>
						<Tooltip imperativeModeOnly ref={tooltipCopyArweave} />
					</div>
				</div>
				<div className="mt-2 flex flex-row items-center gap-x-2">
					<TypographyLabel
						size="medium"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						IPFS CID:
					</TypographyLabel>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.ipfsCID}
					</TypographyParagraph>
					<div id="copyIPFS" className="flex flex-row">
						<CopyIcon
							className="h-4 w-4 text-textSecondaryLight hover:cursor-pointer dark:text-textSecondaryDark"
							onClick={() => {
								navigator.clipboard.writeText(tweet.ipfsCID)
								tooltipCopyIPFS.current?.open({
									anchorSelect: '#copyIPFS',
									content: 'Copied!',
								})
								setTimeout(() => {
									tooltipCopyIPFS.current?.close()
								}, 2000)
							}}
						/>
						<Tooltip imperativeModeOnly ref={tooltipCopyIPFS} />
					</div>
				</div>
				<div className="mt-2 flex flex-row items-center gap-x-2">
					<TypographyLabel
						size="small"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						{formatDate(tweet.timestamp)}
					</TypographyLabel>
					{/*<a href={tweet.arweaveURL} target="_blank">
                        <OpenInNewIcon className="w-4 h-4 hover:cursor-pointer text-textSecondaryLight dark:text-textSecondaryDark"/>
                    </a>*/}
				</div>
				<Image
					className="mt-6 h-auto w-4/5"
					imageUrl={tweet.image}
					imageAlt={tweet.image}
				></Image>
			</div>
			<div className="flex flex-col rounded bg-uiTertiaryLight p-4 dark:bg-uiTertiaryDark">
				<TypographyHeading
					size="small"
					isBold={true}
					additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
				>
					Arweave tags
				</TypographyHeading>
				<div className="flex flex-row items-center gap-x-2 border-b border-dotted border-grey600 py-4">
					<Tag showIcon={false}>Publisher</Tag>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.publisher}
					</TypographyParagraph>
				</div>
				<div className="flex flex-row items-center gap-x-2 border-b border-dotted border-grey600 py-4">
					<Tag showIcon={false}>AF-App</Tag>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.app}
					</TypographyParagraph>
				</div>
				<div className="flex flex-row items-center gap-x-2 border-b border-dotted border-grey600 py-4">
					<Tag showIcon={false}>AF-Template</Tag>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.template}
					</TypographyParagraph>
				</div>
				<div className="flex flex-row items-center gap-x-2 border-b border-dotted border-grey600 py-4">
					<Tag showIcon={false}>Content-Type</Tag>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.contentType}
					</TypographyParagraph>
				</div>
				<div className="flex flex-row items-center gap-x-2 border-b border-dotted border-grey600 py-4">
					<Tag showIcon={false}>Social-Platform</Tag>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.platform}
					</TypographyParagraph>
				</div>
				<div className="flex flex-row items-center gap-x-2 border-b border-dotted border-grey600 py-4">
					<Tag showIcon={false}>Social-Username</Tag>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.username}
					</TypographyParagraph>
				</div>
				<div className="flex flex-row items-center gap-x-2 border-b border-dotted border-grey600 py-4">
					<Tag showIcon={false}>Social-URL</Tag>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.url}
					</TypographyParagraph>
				</div>
				<div className="flex flex-row items-center gap-x-2 py-4">
					<Tag showIcon={false}>IPFS-CID</Tag>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.ipfsCID}
					</TypographyParagraph>
				</div>
			</div>
			<div className="flex flex-col rounded bg-uiTertiaryLight p-4 dark:bg-uiTertiaryDark">
				<TypographyHeading
					size="small"
					isBold={true}
					additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
				>
					Arweave signature
				</TypographyHeading>
				<TypographyParagraph
					size="medium"
					additionalClasses="text-textPrimaryLight dark:text-textSecondaryDark break-words"
				>
					{tweet.signature}
				</TypographyParagraph>
			</div>
		</div>
	)
}
